import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authenticationService: AuthenticationService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Add authorization header with jwt token if available.
    // Skip if token is too large to avoid RequestHeaderSectionTooLarge (8KB limit).
    const MAX_AUTH_HEADER_BYTES = 4096;
    let currentUser = this.authenticationService.currentUserValue;
    if (currentUser && currentUser.idtoken) {
      const token = String(currentUser.idtoken);
      const tokenBytes = new Blob([token]).size;
      if (tokenBytes <= MAX_AUTH_HEADER_BYTES) {
        request = request.clone({
          setHeaders: {
            Authorization: token,
          },
        });
      } else {
        console.warn(
          `[JwtInterceptor] Authorization token too large (${tokenBytes} bytes). Not sent to avoid 413. Clear localStorage and re-login.`
        );
      }
    }
    const localDev = window.location.href.indexOf('.com') === -1; //location.host
    const serverlessApi = this.isServerlessApi(request.url);

    if (localDev && serverlessApi) {
      request = this.getAroundCorsPolicy(request);
    }

    return next.handle(request);
  }

  private isServerlessApi(url: string): boolean {
    if (!url) {
      return false;
    }

    if (/api./.test(url)) {
      return true;
    }

    return false;
  }

  private getAroundCorsPolicy(req: HttpRequest<any>): HttpRequest<any> {
    if (/dev.api.rb/.test(req.url)) {
      return req.clone({
        url: req.url.replace('https://dev.api.rb.wginb.com', ''),
      });
    }
    if (/dev.api.sso/.test(req.url)) {
      return req.clone({
        url: req.url.replace('https://dev.api.sso.wginb.com', ''),
      });
    }
    return req;
  }
}
